<div
  class="umss-table-wrapper"
  [class.full-width]="fullWidth"
  [class.bordered]="bordered"
>
  <table class="umss-table" [class.dense]="density === 'Compact'">
    <thead class="umss-table-header">
      <ng-content select="[umssTableHeader]"></ng-content>
    </thead>
    <tbody class="umss-table-body">
      <ng-content select="[umssTableBody]"></ng-content>
    </tbody>
  </table>
</div>
